import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { NxiRestService } from './services/NXI-Rest.service';
import { ComponentTitleComponent } from './components/component-title/component-title.component';
import { LanguageSwitchComponent } from './components/language-switch/language-switch.component';
import { MStarComponentLoaderComponent } from './components/mstar-component-loader/mstar-component-loader.component';
import { LoginReviewDialogComponent } from './components/LoginReviewTemplate/login-review-dialog';
import { MatCardModule } from '@angular/material/card';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GridExportService } from './services/grid-export-service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DownloadExcelComponent } from './components/download-excel/download-excel.component';
import { AccountDisplayPipe } from './pipes/account-display.pipe';
import { NxiCarouselComponent } from './components/nxi-carousel/nxi-carousel.component';
import { NguCarousel } from './components/ngu-carousel/ngu-carousel.component';
import { NguTileComponent } from './components/ngu-tile/ngu-tile.component';
import { NguItemComponent } from './components/ngu-item/ngu-item.component';
import { NguCarouselDefDirective, NguCarouselItemDirective, NguCarouselNextDirective, NguCarouselOutlet, NguCarouselPointDirective, NguCarouselPrevDirective } from './directives/ngu-carousel.directive';

@NgModule({
  declarations: [
    ComponentTitleComponent, LanguageSwitchComponent, MStarComponentLoaderComponent, LoginReviewDialogComponent,
    DownloadExcelComponent, NxiCarouselComponent,
    AccountDisplayPipe,
    NguCarousel,
    NguTileComponent,
    NguItemComponent,
    NguCarouselPointDirective,
    NguCarouselItemDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguCarouselDefDirective,
    NguCarouselOutlet
  ],
  imports: [
    PershingCoreModule, PershingCommonModule, PortalModule, OverlayModule, MatTooltipModule, MatMenuModule
    , MatCardModule, MatDialogModule, MatButtonModule, MatSnackBarModule
  ],
  exports: [
    PershingCoreModule, PershingCommonModule, ComponentTitleComponent, LanguageSwitchComponent, MStarComponentLoaderComponent,
    LoginReviewDialogComponent, DownloadExcelComponent, AccountDisplayPipe, NxiCarouselComponent,
    NguCarousel,
    NguTileComponent,
    NguItemComponent,
    NguCarouselPointDirective,
    NguCarouselItemDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguCarouselDefDirective,
    NguCarouselOutlet,
  ],
  providers: [
    NxiRestService,
    GridExportService,
    AccountDisplayPipe
  ],
  entryComponents: [
    LoginReviewDialogComponent
  ]
})

export class NxiCommonModule {}
